module.exports = __webpack_public_path__ + "img/bg-image1.42fdd43e.png";